export const postStatusEnum = {
  approved: 'approved',
  rejected: 'rejected',
};

export const rssFeedListActionsEnum = {
  forceOpenGraph: 1,
  disable: 2,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};
